module.exports = __webpack_public_path__ + "img/correlation.bbd35af6.png";